import { i18n } from 'i18next'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function DwemerBootsFooterLangListener({
  dwemerBootsI18n,
}: {
  dwemerBootsI18n: i18n
}) {
  const { i18n } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!dwemerBootsI18n || !dwemerBootsI18n.language) return
    if (i18n.language !== dwemerBootsI18n.language) {
      const { pathname, search } = window.location
      const newPath = pathname.replace(i18n.language, dwemerBootsI18n.language)
      navigate(`${newPath}${search}`, { replace: true })
    }
  }, [dwemerBootsI18n.language])

  return null as React.ReactNode
}
